import { Box, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { useEffect, useState } from "react";
import { BalootUserAPIs, UserAPIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useNavigate } from "react-router-dom";
import IconRowWithArrow from "../../components/shared/IconRowWithArrow";
import { ReactComponent as ProfileIcon } from "../../assets/icons/profile-logo.svg";
import { ReactComponent as SettingIcon } from "../../assets/icons/setting-colored.svg";
import { ReactComponent as AccountIcon } from "../../assets/icons/accountIcon.svg";
import { ReactComponent as SupportIcon } from "../../assets/icons/support-colored.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout-colored.svg";
import { ReactComponent as GiftIcon } from "../../assets/icons/gift-colored.svg";
import { ReactComponent as BonusIcon } from "../../assets/icons/bonus.svg";
import moment from "moment-jalaali";
import CustomTextSkeleton from "../../components/shared/CustomTextSkeleton";
import { ActionModal } from "../../components/shared/ActionModal";
import { toToman } from "../../utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../store/actions/ConfigActions";

function ProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config } = useSelector((state) => state.config);
  const [openModal, setOpenModal] = useState(false);
  const {
    loading,
    result,
    apiCall: getUserAccount,
  } = useRequest(BalootUserAPIs.getUserAccount, true);

  const { loading: logoutLoading, apiCall: logout } = useRequest(
    UserAPIs.logout
  );

  const onLogout = () => {
    logout({
      onSuccess: () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        navigate("/auth/register");
      },
    });
  };

  useEffect(() => {
    getUserAccount({
      onSuccess: (response) => {
        dispatch(
          setConfig({
            config: {
              ...config,
              onlineSupportUrl: response.onlineSupportUrl,
            },
          })
        );
      },
    });
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <Typography variant="h5" color={"common.white"}>
            حساب کاربری
          </Typography>
        }
      />
      <Box
        sx={{
          width: "100%",
          position: "relative",
          zIndex: 1,
          mb: "-70px",
          px: "24px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minHeight: 60,
            px: "24px",
            py: "16px",
            boxShadow: (theme) => theme.shadows[2],
            bgcolor: "common.white",
            borderRadius: "20px",
          }}
        >
          <ProfileIcon width={48} height={48} />
          <Box
            sx={{
              ml: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {loading ? (
              <>
                <CustomTextSkeleton width={100} />
                <CustomTextSkeleton width={80} />
              </>
            ) : (
              result && (
                <>
                  <Typography variant="h5" color="grey.2">
                    {`${result?.personalInfo?.firstName} ${result?.personalInfo?.lastName}`}
                  </Typography>
                  <Typography variant="subtitle1" color="grey.3">
                    {`سرمایه‌گذار از: ${moment(
                      result?.investmentStartDate
                    ).format("jYYYY/jMM/jDD")}`}
                  </Typography>
                </>
              )
            )}
          </Box>
        </Box>
      </Box>
      <PageContentContainer
        sx={{
          mt: "20px",
          overflow: "auto",
          pt: 9,
          display: "block",
        }}
      >
        {[
          {
            title: "تکمیل حساب",
            icon: AccountIcon,
            value:
              result && result.completionPercent
                ? `%${result?.completionPercent}`
                : "0",
            valueColor: "primary.main",
            variant: "h5",
            action: () => {
              navigate("/app/profile/account");
            },
          },
          {
            title: "تنظیمات",
            icon: SettingIcon,
            action: () => {
              navigate("/app/profile/setting");
            },
          },
          {
            title: "پشتیبانی",
            icon: SupportIcon,
            action: () => {
              navigate("/app/profile/support");
            },
          },
          {
            title: "کارت هدیه",
            icon: GiftIcon,
            action: () => {
              navigate("/app/profile/gift");
            },
          },
          {
            title: "دعوت از دوستان",
            icon: BonusIcon,
            value: `${toToman(result?.campaignBonus)} تومان
            
            `,
            greenBox: true,
            action: () => {
              navigate("/app/profile/referral");
            },
          },
          {
            title: "خروج",
            icon: LogoutIcon,
            action: () => {
              setOpenModal(true);
            },
          },
        ].map((item) => {
          return (
            <IconRowWithArrow
              sx={{ mb: "24px" }}
              key={item.title}
              title={item.title}
              icon={item.icon}
              greenBox={item.greenBox}
              onClick={item.action}
              value={item.value}
              valueColor={item.valueColor}
              variant={item.variant}
            />
          );
        })}
      </PageContentContainer>
      <ActionModal
        open={openModal}
        setOpen={setOpenModal}
        icon={LogoutIcon}
        title="خروج از حساب کاربری"
        description="آیا می‌خواهید ازحساب کاربری خود خارج شوید؟"
        isContained={false}
        actionTitle="خروج"
        action={onLogout}
        cancelTitle="بستن"
        loading={logoutLoading}
      />
    </>
  );
}

export default ProfilePage;
